module.exports = __webpack_public_path__ + "static/media/Evora 2.1807f3c8.png";